<template>
  <MyCaseFlyoutComponent>
    <template #body>
      <MyCaseSection
        back-button
        @back-click="setMyCaseFlyoutName('core')">
        <template #header>
          <h5 class="mb-0">
            Quarterly Rental Complete
          </h5>
        </template>
        <template #body>
          <div class="d-flex flex-column mt-xxl align-items-center justify-content-center">
            <SvgCircleIcon
              :height="36"
              :width="36"
              class="p-sm"
              variant="success">
              <SvgCheck/>
            </SvgCircleIcon>
            <p class="mt-md small-text">
              Your quarterly rental is confirmed!
            </p>
            <div class="w-100 mt-xxl">
              <CaseItem
                :package-item="itemToRent"
                :show-buy-button="false"
                :show-review-button="false"
                :show-return-button="false"/>
            </div>            
          </div>
        </template>
      </MyCaseSection>
    </template>
  </MyCaseFlyoutComponent>
</template>

<script setup>
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useCaseStore } from '@/stores/case.js'
import MyCaseFlyoutComponent from '../common/MyCaseFlyoutComponent'
import MyCaseSection from '../common/MyCaseSection'
import SvgCircleIcon from '@/components/global/svg/SvgCircleIcon.vue'
import SvgCheck from '@/components/global/svg/SvgCheck.vue'
import CaseItem from '../caseItem/CaseItem.vue'

const caseStore = useCaseStore()
const { itemToRent } = storeToRefs(caseStore)

const setMyCaseFlyoutName = (name) => {
  caseStore.setMyCaseFlyoutName(name)
}

onMounted(() => {
  setTimeout(() => {
    setMyCaseFlyoutName('core')
    caseStore.setCoreTabById('quarterly-rentals')
  }, 2000)
})
</script>